import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const RiskTradeChart = ({ data }) => {
  const [options, setOptions] = useState({
    responsive: [
      {
        breakpoint: 425,
        options: {
          chart: {
            height: 350,
            width: 300,
          },
        },
      },
      {
        breakpoint: 325,
        options: {
          chart: {
            height: 300,
            width: 250,
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top", // Position legend at the top
      horizontalAlign: "right",
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 10,
        height: 10,
      },
    },
    colors: ["#0D56EA", "#8B3231"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    labels: [],

    tooltip: {
      show: true,
    },

    xaxis: {
      categories: [],
      tooltip: {
        enabled: true,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Risk($) per trade",
        title: {
          // text: "Risk($) per trade",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value).toFixed(2),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
      {
        opposite: true,
        seriesName: "Risk(%) per trade",
        title: {
          // text: "Risk(%) per trade",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value).toFixed(2),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      // x: {
      //   show: false,
      // },
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      // custom: function ({ series, seriesIndex, dataPointIndex }) {
      //   return (
      //     '<div class="arrow_box">' +
      //     '<div class="Annotation-box Date">' +
      //     "<div></div>" +
      //     "<span></span>" +
      //     "</div>" +
      //     "<div>" +
      //     `<svg width="150" height="1" viewBox="0 0 150 1" fill="none" xmlns="http://www.w3.org/2000/svg">
      //                <line x1="0.5" y1="0.5" x2="149.5" y2="0.5" stroke="url(#paint0_radial_430_8036)" strokeLinecap="round"/>
      //                <defs>
      //                <radialGradient id="paint0_radial_430_8036" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(77.9279 1) rotate(180) scale(77.9279 24238.7)">
      //                <stop offset="0.42336" stopColor="white"/>
      //                <stop offset="1" stopColor="white" stopOpacity="0"/>
      //                </radialGradient>
      //                </defs>
      //                </svg>` +
      //     `</div>` +
      //     '<div class="Annotation-box Yellow mbb-5">' +
      //     "<div>Risk($) per trade - </div>" +
      //     "<span>" +
      //     Number(series[seriesIndex][dataPointIndex]).toFixed(2) +
      //     "</span>" +
      //     "</div>" +
      //     '<div class="Annotation-box Blue mbb-5">' +
      //     "<div> Risk(%) per trade - </div>" +
      //     "<span>" +
      //     Number(series[seriesIndex + 1][dataPointIndex]).toFixed(2) +
      //     "</span>" +
      //     "</div>" +
      //     "</div>"
      //   );
      // },
    },
  });

  const [series, setSeries] = useState([
    {
      name: "Risk($) per trade",
      type: "line",
      data: [],
    },
    {
      name: "Risk(%) per trade",
      type: "line",
      data: [],
    },
  ]);

  useEffect(() => {
    if (data) {
      setOptions((prev) => ({
        ...prev,
        labels: data.position,
      }));

      setSeries([
        {
          name: "Risk($) per trade",
          type: "line",
          data: data.risk,
        },
        {
          name: "Risk(%) per trade",
          type: "line",
          data: data.risk_percent,
        },
      ]);
    }
  }, [data]);

  const hasData =
    data &&
    data.risk &&
    data.risk_percent &&
    data.risk.length > 0 &&
    data.risk_percent.length > 0;

  return (
    <div id="chart" className="RiskTradeChart">
      {hasData ? (
        <ReactApexChart options={options} series={series} height={280} />
      ) : (
        <div className="no-data">No Data Available</div>
      )}
    </div>
  );
};

export default RiskTradeChart;
